// extracted by mini-css-extract-plugin
export default {"pomTokenModule":"POMToken_pomTokenModule__YI1rv","infoSection":"POMToken_infoSection__Q4Urt","accounts":"POMToken_accounts__p6C4x","link":"POMToken_link__lKQ9V"};